import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=55bedbde&scoped=true"
import script from "./TransferFunds.vue?vue&type=script&lang=js"
export * from "./TransferFunds.vue?vue&type=script&lang=js"
import style0 from "./TransferFunds.vue?vue&type=style&index=0&id=55bedbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bedbde",
  null
  
)

export default component.exports